export default class Atendimento {
  constructor(obj) {
    obj = obj || {};
    this.idUsuario = obj.idUsuario;
    this.loginUsuario = obj.loginUsuario;
    this.codigoChamada = obj.codigoChamada;
    this.diasEmAberto = obj.diasEmAberto;
  }
}
